// Ordered domain IDs for consistent domain list ordering across the application
export const ORDERED_DOMAIN_IDS = [
  'VCD_PTC_PTO1_Release',
  'VCD_PTC_PTO2_Release',
  'VCD_PTC_PTO3_Release',
  'VCD_PTC_Engine_Mounted_PTO',
  'VCD_PTC_PTO_W',
  'VCD_PTC_Nominal_Engine_Speed_Specifications',
  'VCD_VDC_Requested_Engine_Speed',
  'VCD_PTC_Status_PTO',
  'VCD_PTC_PTO_Interface',
]
